import React from 'react';
import './Guides.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { CustomTypoH2, CustomTypoH6Gray } from '../../helper/headings';

import ReqDemoAndSignupSection from '../../components/req_demo_or_signup_section';
import SectionBanner from '../../components/Banner';

import Guide2SVG from '../../assets/guides/guides_2.svg';
import Guide3SVG from '../../assets/guides/guides_3.svg';
import AppNavBar from '../../helper/appbar';

const Guides = () => {
    const navigateToSite = () => {
        window.open("http://gokardinal.hubspotpagebuilder.eu/travel-policy", "_blank");
    };

    const navigateToStrategic = () => {
        window.open("http://gokardinal.hubspotpagebuilder.eu/travel-policy", "_blank");
    };

    return (
        <div className='guide_main_section'>
            <AppNavBar navType={'_green'} />
            <SectionBanner
                title={'Guides'}
                tagline={"Corporate travel jargon simplified for you."}
            />
            <Container fluid>
                <section className='cards-container'>
                    <CustomTypoH2 typo={"All guides"} />
                    <Row className='rectangle1'>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} className="imageContainer">
                            <img src={require('../../assets/guides/bagArrowImage.png')} alt={"bag"} />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} className="rectangleText">
                            <CustomTypoH2
                                typo="Travel Policy Guide For Your Business"
                            />
                            <CustomTypoH6Gray
                                typo={"Learn how to effectively plan, book and approve trips as an admin, finance, travel or HR manager."}
                            />
                            <p className='linkText' onClick={navigateToSite}>
                                {"Get this policy"}
                            </p>
                        </Col>
                    </Row>

                    <Row className='rectangle'>
                        <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} lg={{ span: 6, order: 1 }} xl={{ span: 6, order: 1 }} className="rectangleText2">
                            <section className='sectionMainText'>
                                <CustomTypoH2
                                    typo="How to manage travel and expenses in 2022"
                                />
                            </section>
                            <CustomTypoH6Gray
                                typo={"Control every aspect of how you travel and how you pay for it"}
                            />
                            <p className='linkText' onClick={navigateToStrategic}>
                                {"See this guide"}
                            </p>
                        </Col>
                        <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 6, order: "last" }} lg={{ span: 6, order: "last" }} xl={{ span: 6, order: "last" }} className="imageContainer2" >
                            <img src={Guide2SVG} alt={"bag"} />
                        </Col>
                    </Row>
                    <Row className='rectangle'>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="imageContainer3">
                            <img src={Guide3SVG} alt={"bag"} />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={6} xl={6} className="rectangleText3">
                            <CustomTypoH2
                                typo="Strategic Ways to Improving Employee Engagement"
                            />
                            <CustomTypoH6Gray
                                typo={"Understand tactical ways to improve employee engagement."}
                            />
                            <p className='linkText'>
                                {"Learn how"}
                            </p>
                        </Col>
                    </Row>
                </section>
            </Container>
            <ReqDemoAndSignupSection
                bgColor={{ background: "linear-gradient(92.64deg, rgba(36, 50, 86, 0.97) 8.04%, #18A0FB 100%)" }}
                title={`Change the way you do business travel`}
                signUpBtnMobile={"Sign up now"}
                signUpBtn={`Sign up for free`}
                reqDemoBtn={`Request Demo`}
            />
        </div>
    );
};

export default Guides;